import React from 'react';
import { Grid, Tooltip, IconButton, Box} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const MetricDetailGridItem = React.memo((props) => {

    const { label, value, tooltip } = props;
  
    return (
      <>
        <Grid item xs={12} sm={3}>
          <label><b>{label}</b></label>
        </Grid>
        <Grid item xs={11} sm={8}>
          <Box 
            sx={{
              whiteSpace: 'pre-line',
              wordBreak: 'break-all',
              maxHeight: '9em',
              overflowY: 'auto',
              lineHeight: 1.5
            }}
          >
            {value}
          </Box>
        </Grid>
        <Grid item xs={1} sm={1}>
          {tooltip ? (
            <Tooltip title={tooltip} leaveDelay={200}>
              <IconButton tabIndex={-1} edge="end" size="small" aria-label="info">
                <InfoOutlinedIcon color="primary" sx={{ fontSize: '1.3rem' }} />
              </IconButton>
            </Tooltip>
          ) : <></>}
        </Grid>
      </>
    );
  });

export default MetricDetailGridItem;